<template>
	<div class="sideways-content-fold" v-if="activePanel">
		<div class="portlet light bordered" v-if="process !== 'next_actions'">
			<div class="portlet-title">
				<div class="caption">
					Create A Business
				</div>
			</div>
			<div class="portlet-body portlet-overflow">
				<form role="form" @submit.prevent="createBusiness($event)" novalidate>
					<div class="alert alert-danger" v-if="errorMessage.length">
					    <button class="close" data-close="alert" @click="clearError()"></button>
                        <span>{{ errorMessage }}</span>
					</div>
					<transition name="fade" mode="out-in">
						<div v-if="process === 'step_1'" key="step_1">
							<div class="form-body invite-user-form">
								<div class="form-group form-md-line-input form-md-floating-label">
		                            <input type="text" class="form-control input-sm" :class="{'edited': newBusiness.business_name.length}" id="create_business_name" v-model.trim="newBusiness.business_name" maxlength="255">
		                            <label for="create_business_name">Business Name</label>
		                        </div>
		                        <div class="form-group form-md-line-input form-md-floating-label">
		                            <input type="text" class="form-control input-sm" :class="{'edited': newBusiness.salesforce_id}" id="create_business_salesforce" v-model.trim="newBusiness.salesforce_id">
		                            <label for="create_business_salesforce">Salesforce ID <small class="font-grey-cascade">(optional)</small></label>
		                        </div>
		                        <div class="form-md-checkboxes">
		                        	<div class="md-checkbox-inline">
		                        		<div class="md-checkbox">
		                        			<input type="checkbox" id="checkbox-blacklisted" class="md-check" v-model="newBusiness.blacklisted">
		                        			<label for="checkbox-blacklisted">
		                        				<span></span>
		                        				<span class="check"></span>
		                        				<span class="box"></span>
		                        				Add {{ newBusiness.business_name || 'this business' }} to the <b>Blacklist</b>.
		                        			</label>
		                        			<info-popover :content="'Blacklisted businesses are not accessible by all UNOapp staff, they need to be individually assigned to each user.'"></info-popover>
		                        		</div>
		                        	</div>
		                        </div>
		                        <!-- <div class="form-md-checkboxes margin-bottom-20">
		                        	<div class="md-checkbox-inline">
		                        		<div class="md-checkbox">
		                        			<input type="checkbox" id="checkbox-trial" class="md-check" v-model="newBusiness.thirty_day_trial">
		                        			<label for="checkbox-trial">
		                        				<span></span>
		                        				<span class="check"></span>
		                        				<span class="box"></span>
		                        				Assign {{ newBusiness.business_name || 'business' }} to <b>30 Day Trial</b>.
		                        			</label>
		                        			<info-popover :content="'A 30 day trial will automatically expire at the end of the 30 day period. The sales and account rep will be notified if they wish to extend the trial period.'"></info-popover>
		                        		</div>
		                        	</div>
		                        </div> -->
		                        <!-- <div class="form-group form-md-line-input form-md-floating-label">
		                    		<typeahead :data="users" :label="'Sales Rep'" :emitter="'salesRep'" @salesRep="updateSalesRep" :multiSearch="true" :multiSearchKeys="multiSearchKeys" :passedValue="newBusiness.sales_rep"></typeahead>
		                        </div>
		                        <div class="form-group form-md-line-input form-md-floating-label">
		                    		<typeahead :data="users" :label="'Account Rep'" :emitter="'accountRep'" @accountRep="updateAccountRep" :multiSearch="true" :multiSearchKeys="multiSearchKeys" :passedValue="newBusiness.account_rep"></typeahead>
		                        </div> -->
							</div>
							<div class="form-actions noborder invite-user-actions margin-top-20">
								<button type="button" class="btn btn-default exit-invitation-setup" @click="closePanel()"> Return To Business Dashboard</button>
								<button type="button" class="btn blue" @click="advanceForm($event, 'step_2', 'step_1')" key="create-business-continue-one">Continue <i class="fa fa-arrow-circle-right"></i></button>
							</div>
						</div>
						<div v-if="process === 'step_2'" key="step_2">
							<div class="form-body invite-user-form">
								<div class="margin-top-20 portlet-title-alternate">Choose a Service Package</div>
								<div class="mt-element-list">
									<div class="mt-list-container list-default no-border">
						    			<ul>
						    				<li class="mt-list-item selected-case" @click="selectServicePackage('easy')">
						    					<div class="list-icon-container" :class="{'done': newBusiness.service_package === 'easy'}">
						    						<a>
						    							<span>1</span>
						    						</a>
						    					</div>
						    					<div class="list-item-content" :class="{'done': newBusiness.service_package === 'easy'}">
						    						<h3 class="uppercase bold">
						    							<a>Easy</a>
						    						</h3>
						    						<p><small>This is a description</small></p>
						    					</div>
						    				</li>
						    				<li class="mt-list-item selected-case" @click="selectServicePackage('assisted')">
						    					<div class="list-icon-container" :class="{'done': newBusiness.service_package === 'assisted'}">
						    						<a>
						    							<span>2</span>
						    						</a>
						    					</div>
						    					<div class="list-item-content" :class="{'done': newBusiness.service_package === 'assisted'}">
						    						<h3 class="uppercase bold">
						    							<a>Assisted</a>
						    						</h3>
						    						<p><small>This is a description</small></p>
						    					</div>
						    				</li>
						    				<li class="mt-list-item selected-case" @click="selectServicePackage('3rd_one')">
						    					<div class="list-icon-container" :class="{'done': newBusiness.service_package === '3rd_one'}">
						    						<a>
						    							<span>3</span>
						    						</a>
						    					</div>
						    					<div class="list-item-content" :class="{'done': newBusiness.service_package === '3rd_one'}">
						    						<h3 class="uppercase bold">
						    							<a>3rd One</a>
						    						</h3>
						    						<p><small>This is a description</small></p>
						    					</div>
						    				</li>
						    			</ul>
						    		</div>
						    	</div>
						    	<!-- <div class="margin-top-20 portlet-title-alternate">Credits</div>
						    	<div class="form-group form-md-line-input form-md-floating-label">
		                            <input type="number" class="form-control input-sm" :class="{'edited': newBusiness.business_credits || newBusiness.business_credits === 0}" id="form_control_1" v-model="newBusiness.business_credits">
		                            <label for="form_control_1">Monthly Business Credits</label>
		                        </div>
		                        <div class="form-group form-md-line-input form-md-floating-label">
		                            <input type="number" class="form-control input-sm" :class="{'edited': newBusiness.location_credits || newBusiness.location_credits === 0}" id="form_control_1" v-model="newBusiness.location_credits">
		                            <label for="form_control_1">Default Monthly Location Credits</label>
		                        </div> -->
							</div>
							<div class="form-actions noborder invite-user-actions margin-top-20">
								<button type="button" class="btn btn-default exit-invitation-setup" @click="closePanel()"> Return To Business Dashboard</button>
								<button type="button" class="btn btn-default" @click="reverseForm()">Back</button>
								<button type="button" class="btn blue" @click="advanceForm($event, 'step_3', 'step_2')" key="create-business-continue-two">Continue <i class="fa fa-arrow-circle-right"></i></button>
							</div>
						</div>
						<div v-if="process === 'step_3'" key="step_3">
							<div class="form-body invite-user-form">
								<div class="margin-top-20 portlet-title-alternate">Build a Product Package</div>
								<div class="margin-top-20 row search-content-4">
			      					<div class="search-table table-responsive">
			      						<table class="table table-striped ta ble-condensed">
			      							<thead>
			      								<tr>
			      									<th></th>
			      									<th><a class="no-click font-grey-mint">Include App</a></th>
			      									<!-- <th><a class="no-click font-grey-mint">Default For Locations <info-popover :content="'These apps will create the default product package that each new location in the business will receive.'"></info-popover></a></th> -->
			      								</tr>
			      							</thead>
			      							<tbody>
			      								<tr v-for="app in apps">
				      								<td><h4>{{ app.app_name }}</h4></td>
				      								<td>
				      									<div class="md-checkbox">
				      										<input type="checkbox" :id="`app_access_business_${app.app_id}`" class="md-check" v-model="app.business_access" @change="forceAppSelection('business_access', app)">	
				      										<label :for="`app_access_business_${app.app_id}`">
				      											<span></span>
				      											<span class="check"></span>
				      											<span class="box"></span>
				      										</label>
				      									</div>
				      								</td>
				      								<!-- <td>
				      									<div class="md-checkbox">
				      										<input type="checkbox" :id="`app_access_location_${app.app_id}`" class="md-check" v-model="app.location_default" @change="forceAppSelection('location_default', app)">
				      										<label :for="`app_access_location_${app.app_id}`">
				      											<span></span>
				      											<span class="check"></span>
				      											<span class="box"></span>
				      										</label>
				      									</div>
				      								</td> -->
				      							</tr>
			      							</tbody>
			      						</table>
			      					</div>
			      				</div>
							</div>
							<div class="form-actions noborder invite-user-actions">
								<button type="button" class="btn btn-default exit-invitation-setup" @click="closePanel()"> Return To Business Dashboard</button>
								<button type="button" class="btn btn-default" @click="reverseForm()">Back</button>
								<button type="submit" class="btn blue" key="create-business-submit">Submit</button>
							</div>
						</div>
					</transition>
					<step-counter :steps="steps" :process="process"></step-counter>
				</form>
			</div>
		</div>
		<next-actions v-else :actionsList="createBusinessNextActions" @runFunction="runFunction"></next-actions>
	</div>
</template>
<script>
import $ from 'jquery'
import NextActions from '../../modules/NextActions'
import StepCounter from '../../modules/StepCounter'
import GlobalFunctions from '../../../global'
import InfoPopover from '../../modules/InfoPopover'
import Typeahead from '../../modules/Typeahead'
import Account from '../../../controllers/Account'
import App from '../../../controllers/App'
import Business from '../../../controllers/Business'
import { findIndex } from 'lodash'
import { mapActions } from 'vuex'

/**
 * Create Business module is a page for creating new businesses.
 * @class CreateBusiness
 * @extends BusinessManager
 * @since 0.0.7
 */

export default {
	name: 'create-business',
	data () {
		return {
			process: 'step_1',
			activePanel: false,
			errorMessage: '',
			newBusiness: {
				business_name: '',
				salesforce_id: '',
				blacklisted: false,
				thirty_day_trial: false,
				sales_rep: {},
				account_rep: {},
				service_package: '',
				business_credits: 0,
				location_credits: 0
			},
			users: [],
			multiSearchKeys: [{key: 'first_name', parent_key: 'name'}, {key: 'last_name', parent_key: 'name'}, {key: 'email', sub_string: true}],
			steps: [{key: 'step_1', name: 'Business Info'}, {key: 'step_2', name: 'Service Package'}, {key: 'step_3', name: 'Product Package'}],
			apps: [],
			createBusinessNextActions: [{title: 'Invite the SuperAdmin', icon_class: 'fa fa-user', main_action: true, description: 'Every Business requires a SuperAdmin to function. The SuperAdmin is the top of the Role Hierarchy and will be repsonsible for passing down all Approval Permissions.', click_event: 'inviteSuperadmin'}, {title: 'Create the First Location', icon_class: 'fa fa-map-marker', description: 'Locations are a representation of each individual business location.', click_event: 'createLocation'}, {title: 'Create Business Roles', icon_class: 'fa fa-user', description: 'Business Roles are used to control Approval Permissions for actions taken within the platform. Roles can also be used to specific which apps a role is able to access.', click_event: 'createRole'}, {title: 'Create Business Regions', icon_class: 'fa fa-sitemap', description: 'Business Regions are groups of locations based on a regional hierarchy. Regions can be used to assign specific users to a location group as well as to manage region specific content for those locations.', click_event: 'createRegion'}, {title: 'Create Another Business', icon_class: 'fa fa-briefcase', click_event: 'resetProcess'}, {title: 'Return to Business Manager Dashboard', icon_class: 'fa fa-arrow-circle-left', click_event: 'closePanel'}],
			createdBusinessId: 0
		}
	},
	/**
	 * Run on `created` to determine if this should be the active panel or not.
	 * @function
	 * @return {undefined}
	 * @memberof CreateBusiness
	 * @version 0.0.7
	 */
	created () {
		if (this.$route.name === 'Business Manager - Create Business') {
			this.activePanel = true
			this.getUserAccounts()
			this.getAppList()
		}
	},
	methods: {
		/**
		 * To clear the current error.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateBusiness
		 * @version 0.0.7
		 */
		clearError () {
			this.errorMessage = ''
		},
		/**
		 * To update the sales rep based on the value sent from the typeahead component
		 * @function
		 * @param {object} val - the selected sales rep object.
		 * @returns {undefined}
		 * @memberof CreateBusiness
		 * @version 0.0.7
		 */
		updateSalesRep (val) {
			if (val) {
				this.newBusiness.sales_rep = val
			} else {
				this.newBusiness.sales_rep = {}
			}
		},
		/**
		 * To update the account rep based on the value sent from the typeahead component
		 * @function
		 * @param {object} val - the selected account rep object.
		 * @returns {undefined}
		 * @memberof CreateBusiness
		 * @version 0.0.7
		 */
		updateAccountRep (val) {
			if (val) {
				this.newBusiness.account_rep = val
			} else {
				this.newBusiness.account_rep = {}
			}
		},
		/**
		 * To pull in a list of UNOapp Business User accounts to use for selected the sales and service reps
		 * @function
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof CreateBusiness
		 * @version 0.0.7
		 */
		getUserAccounts () {
			const businessId = 1
			let _this = this
			let searchCriteria = {
				invite_status: 'accepted'
			}
			let sortCriteria = {
				sort_by: 'first_name',
				sort_order: 'asc'
			}

			return Account.getUsers(businessId, 1, 100, 'unoapp', searchCriteria, sortCriteria).then(response => {
				_this.users = response.payload.accounts
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {

					default:
						// No default
					}
				}
			}))
		},
		/**
		 * To pull in a list of all available apps to be chosen from for the new business.
		 * @function
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof CreateBusiness
		 * @version 0.0.7
		 */
		getAppList () {
			let _this = this

			return App.getApps().then(response => {
				const defaultApps = {business_access: false, location_default: false}
				_this.apps = response.payload.business_apps

				_this.apps.forEach((apps, index, allApps) => {
					allApps[index] = Object.assign({}, apps, defaultApps)
				})
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {

					default:
						// No default
					}
				}
			}))
		},
		/**
		 * To validate that all information on the current step is accurate before allowing the user to proceed.
		 * @function
		 * @param {string} step - The step to be tested.
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof CreateBusiness
		 * @version 0.0.7
		 */
		validateFormData (step) {
			let _this = this

			return new Promise((resolve, reject) => {
				switch (step) {
				case 'step_1':
					if (_this.newBusiness.business_name.length < 3) {
						reject('Business name must be at least 3 characters')
					}
					// if (!_this.newBusiness.sales_rep.account_id && !_this.newBusiness.account_rep.account_id) {
					// 	reject('A Business needs to have a Sales and/or Account Rep')
					// }
					break

				case 'step_2':
					if (!_this.newBusiness.service_package.length) {
						reject('A Business must have a Service Package')
					}
					break

				case 'step_3':
					const businessAppsSelected = _this.apps.filter(app => { return app.business_access }).length >= 1
					// const locationAppsSelected = _this.apps.filter(app => { return app.location_default }).length >= 1

					if (!businessAppsSelected) {
						return _this.$swal({
							title: 'Are you sure?',
							html: 'Do you want to create this business with no app access?',
							type: 'warning',
							showCancelButton: true,
							confirmButtonText: 'Create Business',
							confirmButtonColor: '#d9534f',
							cancelButtonText: 'Cancel',
							allowOutsideClick: false,
							allowEscapeKey: false,
							allowEnterKey: false,
							showLoaderOnConfirm: true
						}).then(() => {
							resolve()
						}, dismiss => {
							reject()
						})
					// } else if (!locationAppsSelected) {
					// 	return _this.$swal({
					// 		title: 'Are you sure?',
					// 		html: 'Do you want to create this business with no default location apps? Each new location will have no app access when created.',
					// 		type: 'warning',
					// 		showCancelButton: true,
					// 		confirmButtonText: 'Create Business',
					// 		confirmButtonColor: '#d9534f',
					// 		cancelButtonText: 'Cancel',
					// 		allowOutsideClick: false,
					// 		allowEscapeKey: false,
					// 		allowEnterKey: false,
					// 		showLoaderOnConfirm: true
					// 	}).then(() => {
					// 		resolve()
					// 	}, dismiss => {
					// 		reject()
					// 	})
					}
					break

				default:
					resolve()
				}

				resolve()
			})
		},
		/**
		 * To move to the next step of the form.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @param {string} step - The step that we are moving to.
		 * @param {string} currentStep - The current step.
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof CreateBusiness
		 * @version 0.0.7
		 */
		advanceForm (event, step, currentStep) {
			let disabledButton = GlobalFunctions.disableButton(event)
			let _this = this

			return this.validateFormData(currentStep).then(response => {
				_this.clearError()
				disabledButton.complete().then(() => {
					_this.process = step
				})
			}).catch(reason => {
				// If validation fails then display the error message
				_this.errorMessage = reason
				disabledButton.cancel()
			})
		},
		/**
		 * To move the form back to the previous step
		 * @function
		 * @returns {undefined}
		 * @memberof CreateBusiness
		 * @version 0.0.7
		 */
		reverseForm () {
			const index = findIndex(this.steps, ['key', this.process])
			if (index) {
				this.process = this.steps[index - 1].key
			}

			return
		},
		/**
		 * To filter the selected apps for use with the create business endpoint
		 * @function
		 * @returns {array} An array of app ids
		 * @memberof CreateBusiness
		 * @version 0.0.7
		 */
		formatAppData () {
			let appData = []

			let filteredApps = this.apps.filter(app => app.business_access)

			filteredApps.forEach(app => {
				appData.push(app.app_id)
			})

			return appData
		},
		/**
		 * To send the details of the new business to the backend.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof CreateBusiness
		 * @version 0.0.7
		 */
		createBusiness (event) {
			let disabledButton = GlobalFunctions.disableButton(event)
			let _this = this

			this.newBusiness.apps = this.formatAppData()

			return _this.validateFormData('step_3')
			.then(response => {
				_this.clearError()
				Business.createBusiness(_this.newBusiness).then(response => {
					_this.createdBusinessId = response.payload.business_id
					_this.clearForm()
					_this.process = 'next_actions'
					disabledButton.complete()
				}).catch(_this.$root.errorWrapper(e => {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
						case 'already_exists':
							_this.errorMessage = 'A business with this name already exists. Please choose a different name.'
							_this.process = 'step_1'
							break

						default:
							// No default
						}
					}
					disabledButton.cancel()
				}))
			}).catch(reason => {
				// If validation fails then display the error message
				if (reason) {
					_this.errorMessage = reason
				}
				disabledButton.cancel()
			})
		},
		/**
		 * To close the create business panel by redirecting to the dashboard
		 * @function
		 * @returns {undefined}
		 * @memberof CreateBusiness
		 * @version 0.0.7
		 */
		closePanel () {
			this.createdBusinessId = 0
			this.process = 'step_1'
			this.$router.push('/app/business_manager')
		},
		/**
		 * To set the active service package.
		 * @function
		 * @param {string} type - The service package we are selecting.
		 * @returns {undefined}
		 * @memberof CreateBusiness
		 * @version 0.0.7
		 */
		selectServicePackage (type) {
			this.newBusiness.service_package = type
		},
		/**
		 * To force the selection of apps when set as a location default or to deselect the default when turning an app off for the business.
		 * @function
		 * @param {string} type - The type of checkbox that was selected.
		 * @param {object} app - The app that is being updated.
		 * @returns {undefined}
		 * @memberof CreateBusiness
		 * @version 0.0.7
		 */
		forceAppSelection (type, app) {
			switch (type) {
			case 'business_access':
				if (app.business_access === false) {
					app.location_default = false
				}
				break

			case 'location_default':
				if (app.location_default === true) {
					app.business_access = true
				}
				break

			default:
				// No Default
			}

			return
		},
		/**
		 * To clear the object 'newBusiness'.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateBusiness
		 * @version 0.0.7
		 */
		clearForm () {
			this.newBusiness = {
				business_name: '',
				salesforce_id: '',
				blacklisted: false,
				thirty_day_trial: false,
				sales_rep: {},
				account_rep: {},
				service_package: '',
				business_credits: 0,
				location_credits: 0
			}
			$('.invite-user-form').find('input, select').removeClass('edited')
		},
		/**
		 * To reset the panel to display the form.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateBusiness
		 * @version 0.0.7
		 */
		resetProcess () {
			this.process = 'step_1'
			this.createdBusinessId = 0

			this.apps.forEach(app => {
				app.location_access = false
			})
		},
		/**
		 * To run the function passed in.
		 * @function
		 * @param {string} functionName - The function that is to be run
		 * @param {array} params - The list of parameters being passed into the function
		 * @returns {undefined}
		 * @memberof CreateBusiness
		 * @version 0.0.7
		 */
		runFunction (functionName, params) {
			if (!params) {
				this[functionName]()
			} else {
				this[functionName](params[0])
			}
		},
		/**
		 * To pull in business details about the created location.
		 * @function
		 * @returns {object} - A promise that either returns the payload or an error message.
		 * @memberof CreateBusiness
		 * @version 0.0.9
		 */
		getBusinessDetails () {
			let _this = this

			return new Promise((resolve, reject) => {
				Business.getBusinessDetails(this.createdBusinessId).then(response => {
					this.setActiveBusinessId(response.payload.business_id)
					this.setActiveBusinessName(response.payload.business_name)
					// store the business_id in localStorage
					/* eslint-disable no-undef */
					localStorage.setItem('activeBusiness', JSON.stringify(response.payload))
					resolve()
				}).catch(_this.$root.errorWrapper(e => {
					if (e.responseJSON) {
						reject(e.responseJSON.declaration)
					} else {
						reject()
					}
				}))
			})
		},
		/**
		 * To set the active business and then redirect to the my business locations page.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateBusiness
		 * @version 0.0.9
		 */
		createLocation () {
			this.getBusinessDetails().then(response => {
				this.$router.push('/app/my_business/locations')
			}).catch(reason => {
				// Error
			})
		},
		/**
		 * To set the active business and then redirect to the my business users page.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateBusiness
		 * @version 0.0.9
		 */
		inviteSuperadmin () {
			this.getBusinessDetails().then(response => {
				this.$router.push('/app/my_business/users')
			}).catch(reason => {
				// Error
			})
		},
		/**
		 * To set the active business and then redirect to the my business roles page.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateBusiness
		 * @version 0.0.9
		 */
		createRole () {
			this.getBusinessDetails().then(response => {
				this.$router.push('/app/my_business/roles')
			}).catch(reason => {
				// Error
			})
		},
		/**
		 * To set the active business and then redirect to the my business regions page.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateBusiness
		 * @version 0.0.9
		 */
		createRegion () {
			this.getBusinessDetails().then(response => {
				this.$router.push('/app/my_business/regions')
			}).catch(reason => {
				// Error
			})
		},
		...mapActions([
			'setActiveBusinessId',
			'setActiveBusinessName'
		])
	},
	components: {
		InfoPopover,
		Typeahead,
		NextActions,
		StepCounter
	},
	watch: {
		/**
		 * To `watch` the $route in order to determine if this panel should be showing or not
		 * @function
		 * @returns {undefined}
		 * @memberof CreateBusiness
		 * @version 0.0.7
		 */
		'$route' () {
			if (this.$route.name === 'Business Manager - Create Business') {
				this.activePanel = true
				this.process = 'step_1'
				this.getUserAccounts()
				this.getAppList()
				this.clearForm()
			} else {
				this.activePanel = false
			}
		}
	}
}
</script>
<style>
.sideways-content-fold {
	position: relative;
}
.sideways-content-fold .mt-element-list .list-default.mt-list-container ul>.mt-list-item.selected-case>.list-icon-container {
	padding: 6px;
    text-align: center;
}
.list-icon-container span {
	font-weight: bold;
    color: #e7ecf1;
    font-size: 25px;
}
.list-icon-container.done span {
    color: #26C281;
}
.mt-element-list .list-default.mt-list-container ul>.mt-list-item.selected-case>.list-item-content.done>h3>a {
	color: #26C281;
}
</style>


// WEBPACK FOOTER //
// CreateBusiness.vue?56c3cb5e